export const CELL_HEIGHT = 125;
export const SURFACE_CARD_RADIUS = 24;
export const SURFACE_CARD_RADIUS_LARGE = 32;
export const SURFACE_CARD_RADIUS_SMALL = 12;
export const RECENTLY_ACTIVE_CELL_WIDTH = 325;
export const BORDER_WIDTH = 2;
export const BORDER_WIDTH_HIGHLIGHTED = 4;
export const GENERIC_ITEM_BORDER_RADIUS = 16;
export const THUMBNAIL_BORDER_RADIUS = 8;
export const LESSON_RECORDING_HEIGHT = 90;
export const SECTION_HEADING_FONT_SIZE = 30;

export const WIDE_LAYOUT_QUERY = "(min-width: 1100px)";
export const CALL_TO_ACTION_MAX_WIDTH = 364;
export const STACKED_CONTENT_MAX_WIDTH = 704;
export const RAIL_EDGE_FADE_WIDTH = 40;

export const UNIT_TILE_MIN_WIDTH = 165;
export const LESSON_CARD_MIN_WIDTH = 300;
export const ASSIGNMENT_CARD_MIN_WIDTH = 325;
